import React from 'react';

export class CurrencySelector extends React.Component {
    render(){
        const {currencies , handleChange , defaultText , isHWGCash , currency } = this.props;

        return (
            currencies.length > 0 && 
            <div className="select is-fullwidth">
                <select value={currency} onChange={handleChange} name="currencyId">
                    <option value=''>{defaultText}</option>
                    {
                        currencies.map(currency => {
                            return (
                                <option key={currency.id} data-type={currency.type} value={currency.id}>{currency.id}</option>
                            )
                        })
                    }
                </select>
            </div>  
        )
    }
}



// WEBPACK FOOTER //
// ./src/_components/Selectors/CurrencySelector.jsx